import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { gaveauModele1 } from '@/demo-data/gaveau-m1';
import { useImportBackupData } from '@/hooks/backup/use-import-backup-data';
export const useLoadDemoData = () => {
  const $ = _c(4);
  const {
    importFullBackup
  } = useImportBackupData();
  let t0;
  if ($[0] !== importFullBackup) {
    t0 = () => {
      try {
        importFullBackup(gaveauModele1);
      } catch {
        throw new Error("Failed to load demo data");
      }
    };
    $[0] = importFullBackup;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const loadDemoData = t0;
  let t1;
  if ($[2] !== loadDemoData) {
    t1 = {
      loadDemoData
    };
    $[2] = loadDemoData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};